export default "__VITE_ASSET__C3oPLHJ0__"